var baseStyle = {
  ml: 0.5
};
var RequiredIndicator = {
  baseStyle: baseStyle
};
export { RequiredIndicator as default };